<template lang="pug">
	.content-static-pages
		.inside
			h4
				router-link.contextual-link(to='/faq')
					span: | Return to FAQ
			ol(type='1')
				li.head: a(href='#' v-scroll-to="'#d-1'")
					span: | What if a planchecker rejects my report?
				li.head: a(href='#' v-scroll-to="'#d-2'")
					span: | What if I'm required to get a third party HERS verification?
				li.head: a(href='#' v-scroll-to="'#d-3'")
					span: | What if a building inspector finds construction not in conformance?
				li.head: a(href='#' v-scroll-to="'#d-4'")
					span: | What if I cannot find component(s) that meet the criteria specified in the report?
				li.head: a(href='#' v-scroll-to="'#d-5'")
					span: | What if I want to change my design after Title 24 compliance has been completed?
				li.head: a(href='#' v-scroll-to="'#d-6'")
					span: | Are there any jurisdictions that are particularly difficult?
				li.head: a(href='#' v-scroll-to="'#d-7'")
					span: | What if my project is in a tough jurisdiction?

			ol(type='1')
				a(id='d-1')
				li: strong
					| What if a planchecker rejects my report?
				p: | Plancheck rejection of an energy compliance report is generally rare. Normally, rejection is due to one, or more, discrepancies between the plans and the report; however, when Standards change (as they did on 1/1/10), the new documentation confuses some plancheckers. The planchecker will give his reason(s) for rejection in a list of plancheck "comments." You should read the comments carefully. Decide whether it is the design, or the Title 24 report (or both) that needs revision. If a consultant's work is not properly coordinated with the design parameters given or fedback to him, then the error/omission is generally his responsibility. Sometimes, simple miscommunication is the culprit.
				p: | Since EasyTitle24.com's do-it-yourself tools use data input by customers, if the data needs revision, it is the customer's responsibility. At this time, the procedure for revising a prior project is to e-mail your request to
					a.contextual-link(href='mailto:customer.service@easytitle24.com')
						span: | &nbsp;customer.service@easytitle24.com&nbsp;
					| tell us either the Project Number (front page of report), the "Input File Name" in the header of any CF1R-PRF-01 form page, the name of the e-mailed file, or the Project Name and date. We will "unlock" the project so that you can edit it, and save the changes. Until we have this process more automated, you will have to call or e-mail us to let us know when you are done editing. We will then manually charge your original card the revision fee, if the revision(s) are simple. If the revisions are complex, it will be treated as a new project.
				a(id='d-2')
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				li: strong
					| What if I'm required to get a third party HERS verification?
				p: | There are currently two agencies that can refer you to certified HERS raters throughout California:
					a.contextual-link(href='https://www.calcerts.com/' target='_blank')
						span: | &nbsp;www.calcerts.com&nbsp;
					| and
					a.contextual-link(href='https://www.cheers.org/' target='_blank')
						span: | &nbsp;www.cheers.org.&nbsp;
					| It might be best to first ask the building department, and/or your builder, architect, or energy consultant if they have a recommendation. The responsibility for hiring the HERS rater is a contractual matter (it is not the building department's responsibility); however, it is the builder who should schedule the HERS inspection at the appropriate time. The logistics are handled mainly by the HERS rater, in coordination with the builder and the building department.
					br
					a.contextual-link(href='/faq-c#c-10')
						span: | What is a HERS measure?
				a(id='d-3')
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				li: strong
					| What if a building inspector finds construction not in conformance?
				p: | When actual construction does not conform to the requirements in the Title 24 report, then it is usually simplest to redo the Title 24 report to correctly reflect the construction. Hopefully this non-compliance will be discovered while there is still time to improve forthcoming construction in order to compensate for the deficiency (if necessary). If construction is already substantially complete, then its possible that redoing the Title 24 report cannot fix the problem without requiring some aspect of the construction to be redone. This problem generally falls on the shoulders of the builder. Rarely will this be a major problem.
				a(id='d-4')
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				li: strong
					| What if I cannot find component(s) that meet the criteria specified in the report?
				p: | This is similar to the field inspection problem in the previous FAQ. The primary approach is to redo the Title 24 report. Perhaps the energy analyst will be able to help you locate the component(s) you need. If not, then he/she can revise the report as needed. It is incumbent upon the builder and/or owner and/or architect to locate, and order, any "premium" construction components well before construction may be impacted by the possible need to change specifications.
				a(id='d-5')
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				li: strong
					| What if I want to change my design after Title 24 compliance has been completed?
				p: | If the change involves the exterior "envelope," mechanical, or water heating systems, then it is advisable to at least seek the energy analyst's advice. If you used EasyTitle24.com's do-it-yourself system, then you should redo your report when your design is completely set, but well before it is built. Otherwise, you risk building a non-conforming structure. Even if non-conformance is not discovered by the building department, it may later be discovered by other inspectors (such as housing inspectors, or real estate inspectors).
				p: | In future, if your design is not settled, but you need Title 24 feedback (when there is a large amount of glazing, for example), you can order "Preliminary Run Results." For most designs, it is advisable to wait until the design is finalized before ordering a full compliance report.
				a.contextual-link(href='/faq-a#a-4')
					span: | Preliminary Run Results
				br
				br
				a(id='d-6')
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				li: strong
					| Are there any jurisdictions that are particularly difficult?
				p: | Our list of difficult jurisdictions is by no means comprehensive. We rely on feedback from customers for this information, and so far such feedback has been sparse. Note that jurisdictions that are difficult in terms of Title 24 plancheck are not necessarily difficult in other areas. Also note that "easy" jurisdictions sometimes hire private plancheckers who can be difficult. Difficult does not necessarily mean knowledgeable either. As far as we know (and this information may be out-of-date), the following jurisdictions are difficult from a Title 24 perspective: City of Fremont; City of La Quinta; City of Los Altos Hills; City of San Ramon; City of Livermore; City of Mill Valley; City of Palmdale; City of Palm Desert; City of Palo Alto; City of Pleasanton; City of Rohnert Park; City of Santa Monica; County of Marin; County of Monterey; County of Napa; County of San Mateo; County of Santa Barbara; County of Ventura. Note that most cities within the difficult counties have their own plancheck departments that are not difficult (unless separately listed). If you wish to "report" a jurisdiction to us, please e-mail
					a.contextual-link(href='mailto:customer.service@easytitle24.com')
						span: | &nbsp;customer.service@easytitle24.com&nbsp;
					| and include your reasoning or anecdote.
				p: | Jurisdictions known to use difficult private plancheckers on a fairly regular basis: City of Danville; City of Berkeley.
				p: | Jurisdictions likely to require a "wet signature" by the energy analyst: City of Palmdale; City of San Diego; County of Santa Barbara.
				a(id='d-7')
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
				br
				br
				li: strong
					| What if my project is in a tough jurisdiction?
				p: | If your project is located in a difficult jurisdiction, headaches will be minimized by hiring a high quality energy analyst for full service Title 24 compliance. EasyTitle24.com can provide this service. For full service projects, we have prepared help-sheets to get you on track:
				ul
					li: a.contextual-link(@click="showModal('What_Additions')")
						strong
							span: | Residential Additions
					li: a.contextual-link(@click="showModal('What_Residential')")
						strong
							span: | New Residences
					li: a.contextual-link(@click="showModal('What_NonResidential')")
						strong
							span: | Commercial

				b-modal(id='modal1' ref="myModalRef" hide-footer size="lg" :title="TitlePop")
					div(v-if="PopState === 'What_Residential'")
						what-Do-You-Need-Residential
					div(v-if="PopState === 'What_Additions'")
						what-Do-You-Need-Additions
					div(v-if="PopState === 'What_NonResidential'")
						what-Do-You-Need-Non-Residential

					div(style="width: 100%; display: flex; justify-content:center;")
						b-button(@click="hideModal" variant="outline-success" style="width: 20%;"): | Close
				a(href='#' v-scroll-to="'#home'")
					span: | back to top
</template>

<script>
import whatDoYouNeedResidential from '@/components/full/pops/residential/whatResidential'
import whatDoYouNeedAdditions from '@/components/full/pops/additions/whatAdditions'
import whatDoYouNeedNonResidential from '@/components/full/pops/nonResidential/whatNonResidential'
export default {
	name: 'faq-d',
	components: {
		whatDoYouNeedResidential,
		whatDoYouNeedAdditions,
		whatDoYouNeedNonResidential
	},
	data () {
		return {
			PopState: '',
			TitlePop: 'Title Pop Up'
		}
	},
	methods: {
		showModal (estado) {
			this.PopState = estado
			this.$refs.myModalRef.show()
			this.changeTitle()
		},
		hideModal () {
			this.PopState = ''
			this.$refs.myModalRef.hide()
		},
		changeTitle () {
			switch (this.PopState[0]) {
			case 'W':
				this.TitlePop = 'What do you need to know'
				break
			case 'T':
				this.TitlePop = 'Transmittal Form'
				break
			default:
				break
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/resources/content-faq-d.vue